var React = require('react');

function Kashflow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"black","d":"M18.986 9.803S1.67-2.23.66 17.506c0 0-2.844-8.213 3.286-13.37 0 0 6.73-6.112 16.653.16l1.106-3.63 7.331 11.015-11.344 1.687c-.032-.032.98-2.133 1.295-3.565Z","key":0}),React.createElement("path",{"fill":"black","d":"M13.014 18.016S30.33 30.049 31.34 10.312c0 0 2.844 8.213-3.286 13.37 0 0-6.73 6.112-16.653-.16l-1.106 3.63-7.268-11.014 11.345-1.624c0-.064-.917 2.07-1.36 3.502Z","key":1})]);
}

Kashflow.defaultProps = {"width":"32","height":"28","fill":"none"};

module.exports = Kashflow;

Kashflow.default = Kashflow;
